<script setup lang="ts">
interface Props {
  size?: 'small' | 'large';
}

const props = withDefaults(defineProps<Props>(), {
  size: 'small',
});
</script>

<template>
  <v-stack
    align="center"
    justify="center"
    :class="['icon-deco-line', `icon-deco-line--${props.size}`]"
  >
    <slot />
  </v-stack>
</template>

<style lang="scss" scoped>
.icon-deco-line {
  position: relative;
  width: 42px;
  height: 42px;
  padding: 9px;
  border: 1px solid var(--color-gray-04-06);
  border-radius: 38% / 38%;
  background-color: var(--color-gray-08-00);
  box-shadow: 2px 2px 7px rgb(0, 0, 0, 0.11);

  &::before {
    position: absolute;
    inset: 2px;
    border: 1px solid var(--color-gray-05-03);
    border-radius: 38% / 38%;
    content: '';
  }

  &--large {
    width: 80px;
    height: 80px;

    &::before {
      inset: 3px;
    }
  }

  :deep(i) {
    background-color: var(--color-gray-03-07) !important;
    color: var(--color-gray-03-07) !important;
  }
}
</style>
